import React from "react";
import { UnsavedChangesModal } from "../../../../components/modals/UnsavedChangesModal/unsaved-changes-modal.component";
import { HiddenHeading } from "../../../pages.styles";
import { CampaignBriefOverviewTabProps } from "./campaign-brief-overview-tab.props";

export const CampaignBriefOverviewTab = (props: CampaignBriefOverviewTabProps) => {
  const Template = props.templateView;

  return (
    <>
      <HiddenHeading>{props.pageTitle}</HiddenHeading>
      <UnsavedChangesModal forceOpen={props.forceOpen} when={props.isDirty} />
      <Template
        ndaData={props.ndaData}
        attachedFiles={props.attachedFiles}
        form={props.form}
        onDeleteFile={props.onDeleteFile}
        onUploadFile={props.onUploadFile}
        userPermissions={props.userPermissions}
      />
    </>
  );
};
